import { connect } from 'react-redux'
import { actions } from 'appRedux/modules/Modal'
import { ListSubBtn } from './ListSubBtn'


const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch, ownProps) => ({
	onModalToggle: (id, open) => dispatch(actions.toggleModal(id, open)),
});


export default connect(mapStateToProps, mapDispatchToProps)(ListSubBtn)
